module.exports = __webpack_public_path__ + "static/img/10.ef61827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/10.png
// module id = r0RV
// module chunks = 0